module.exports = __webpack_public_path__ + "media/offers/offer-poziom-black-3853de8d.png";